import React, { Component } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import * as auth from "../../store/ducks/auth.duck";
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Divider, Link, Tab } from '@material-ui/core';
import MaterialTable from 'material-table';
import Chart from "react-google-charts";
import asyncValidate from './asyncValidate';
import { Button, Popover, PopoverHeader, PopoverBody, TabPane } from 'reactstrap';
import ReactDOM from 'react-dom';
import { Overlay } from 'react-bootstrap';
import { Helmet } from 'react-helmet'
import UserCreateApi from '../../api/Scoreboardapi';

import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from './Modal';

library.add(fas)

class Privacy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            i_agree: false,
            displayError: false,
            alert:'',
            showModal: false,
        };
    }

    componentDidMount() {
        document.body.style.backgroundImage="url(/images/loginbg.gif)";
    }

    handleChange = (event) => {
        let displayError = true;
        if(!this.state.i_agree)
        {
            displayError = false;
        }
        this.setState({
            i_agree: !this.state.i_agree,
            displayError: displayError,
        });
    }

    hideModel=()=>{
        this.setState({alert:''})
        // this.props.history.push('/dashboard');
    }

    handleFormSubmit = (event) => {
        event.preventDefault();

        if(this.state.i_agree) {

            const formData={
                "firstLogin" : 1,
            };

            UserCreateApi.post('user/updatefirstlogin',formData)
            .then((res) => {
                if(res.data.success)
                {
                    if (res.data.message == '1') {
                        this.props.history.push('/dashboard');
                    } else {
                        this.props.history.push('/change-password');
                    }
                }
                else
                {
                    this.displayAlert(res.data.message, '', res.data.success == true ? 'success' : 'error')
                }
            });
        }
        else
        {
            this.setState({
                displayError: true,
            })
        }
    }

    displayAlert=(title, message, type)=>{
        if(type == 'success') {
            this.setState({
                alert:< SweetAlert
                        success
                        title={title}
                        onConfirm={() => this.hideModel()} >
                        {message}
                    </SweetAlert>,
                showModal: ! this.state.showModal,
            })
        }
        else {
            this.setState({
                alert:< SweetAlert
                    error
                    title={title}
                    onConfirm={() => this.setState({alert:'', showModal: ! this.state.showModal})} >
                    {message}
                </SweetAlert>,
                showModal: ! this.state.showModal,
            })
        }
    }

    render() {
        const { showModal } = this.state;

        return (
            <>

                {
                    showModal ? (
                        <Modal>
                            {this.state.alert}
                        </Modal>
                    ) : null
                }
            <Helmet>
                <title>Privacy Policy | Scorecard</title>
            </Helmet>
        <div className="kt-login__body log-in">
        <div className="kt-login__form privacy-page">
          <div className="m-login__logo">
            <center>
            <a href="#">
                <img src="/images/referral-new-logo.png" />
              </a>
            </center>
          </div>
          <div>
            <div className="login-header p-0 pl-3 privacy-page">
              <FontAwesomeIcon icon={["fas", "user-secret"]} color="white" />
              <h4 className="py-3 pl-2 bg-dark text-white text-left mb-0 rounded-2 d-inline-block align-items-center rounded-top rounded-right">Privacy Statement</h4>
            </div>
            <form className="agree-form m-login__form m-form bg-white pt-3 p-4" id="login-form" method="POST" onSubmit={this.handleFormSubmit}>
                        <h2 className="text-black-50">Privacy Statement:</h2>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            AdaptHealth, LLC (“AdaptHealth”) maintains the AdaptHealth DME portal (the “Portal”). This Portal User Agreement (“Agreement”) governs your use of the Portal. Do not use the Portal if you do not agree to the terms of this Agreement. AdaptHealth reserves the right, at its discretion, to update or revise this Agreement at any time. Check this Agreement periodically for changes. Your continued use of the Portal following the posting of any changes to this Agreement constitutes your acceptance of those changes. Changes will apply immediately but not retroactively.
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            1. <strong>Ownership.</strong> The Portal is protected by copyright and trademark laws and is AdaptHealth’s property. You do not have any rights, title, or interest in the Portal. AdaptHealth may suspend, block, or terminate your ability to access or use the Portal at any time for any reason or for no reason and without liability to you.
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            2. <strong>Restrictions.</strong> You will not: (1) license, sublicense, sell, resell, transfer, assign, distribute, or otherwise commercially exploit or make available to any third party any portion of the Portal in any way; (2) copy, modify, adapt, alter, translate, create derivative works, reverse engineer, decompile, disassemble, or otherwise attempt to learn the source code, structure, or ideas upon which the Portal is based; (3) use the Portal to develop a competing website, product, or service; (4) use any device, software, or routine intended to damage or interfere with how the proper functioning of the Portal; (5) do anything that interferes with any other person’s use of the Portal; (6) decrypt, transfer, frame, or mirror the Portal; (7) circumvent AdaptHealth’s or the Portal’s security measures; (8) use the Portal for unlawful purposes; (9) use a bot or spider to harvest or scrape any content on the Portal; (10) use the Portal in a way that misappropriates a trade secret or infringes someone’s intellectual property rights; (11) delete, modify, hack, or attempt to change the Portal; or (12) allow or assist any third party to do the foregoing. AdaptHealth will investigate and prosecute your violation(s) of any of the foregoing to the fullest extent of the law.
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            3. <strong>Safeguards & Protected Health Information.</strong> You agree that you are responsible for implementing reasonable and appropriate administrative, technical, and physical safeguards to protect the confidentiality, integrity, and availability of all Protected Health Information (as defined as defined under Health Insurance Portability and Accountability Act of 1996, and the rules and regulations promulgated thereunder, as may be amended from time to time (collectively, “HIPAA”) and any and all other confidential information accessible on or through the Portal. You agree that you will access the Portal with respect only to those individuals who are your patients at the time you obtain access to the records of such patients (“Your Patients”) and you will use or disclose Protected Health Information concerning Your Patients solely for your own treatment, payment and certain health care operations, as those terms are defined in the Privacy Rule, as otherwise permitted with or without authorization (to the extent such authorization is obtained) under HIPAA.
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            4. <strong>Disclaimers. AdaptHealth provides the Portal on an “as is” and “as available” basis. AdaptHealth specifically disclaims warranties of any kind for the Portal and content available on the Portal, whether expressed or implied, including but not limited to warranties of title, implied warranties of merchantability or warranties of fitness for a particular purpose. You expressly agree that your access to, viewing of, browsing, visiting, or use of the Portal or use of content available on the Portal is at your sole risk. </strong>
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            5. <strong>Liability. To the extent permitted by law, under no circumstance will AdaptHealth be responsible for lost profits, revenues, financial losses, or indirect, special, consequential, exemplary, or punitive damages. To the extent permitted by law, AdaptHealth’s total liability for any claims under this Agreement, including for any implied warranties, is limited to $50.00. The limitations of this section will apply to any theory of liability, whether based on warranty, contract, statute, tort (including negligence) or otherwise, and whether or not AdaptHealth have been informed of the possibility of any such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.</strong>
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            6. <strong>Indemnification.</strong> You agree to defend, indemnify, and hold AdaptHealth and AdaptHealth’s officers, members, managers, employees, and agents harmless from and against any and all claims, liabilities, damages, losses, demands, or expenses, including attorney’s fees and costs and expenses, arising out of or in any way connected with your use of the Portal, your breach or alleged breach of this Agreement, or your violation of any rights of any other person.
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">
                            7. <strong>Governing Law & Miscellaneous Terms.</strong> This Agreement will be governed by and construed in accordance with the laws of the State of Pennsylvania, excluding its conflicts of law rules. You expressly agree that the jurisdiction for any claim or action arising out of or relating to this Agreement or your use of the Portal must be filed in the state or federal courts located in the State of Pennsylvania, and you further agree and submit to the exercise of personal jurisdiction of such courts for the purpose of litigating any such claim or action. This Agreement controls the relationship between AdaptHealth and you. This Agreement does not create any third party beneficiary rights. AdaptHealth’s failure to enforce the provisions of this Agreement does not constitute a waiver of our right to enforce them. If any term or provision of this Agreement will be held to be invalid, illegal, or unenforceable, the remaining terms and provisions of this Agreement will remain in full force and effect, and such invalid, illegal, or unenforceable term or provision will be deemed not to be part of this Agreement. You may not assign or transfer any of your rights under this Agreement. AdapthHealth can assign or transfer this Agreement at any time without your permission.
                        </h5>
                        <br/>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">AdaptHealth welcomes your comments regarding
                            the Terms of Use and Privacy Statements in
                            this
                            User Agreement. If you do not agree with this agreement, please contact us immediately:
                            <a href="mailto:referralsupport@adapthealth.com"> referralsupport@adapthealth.com</a> and we will use
                            commercially reasonable efforts to promptly
                            determine and remedy the problem/concern.
                        </h5>
                        <br/>
                        <h5 className="text-black-50 font-weight-normal">If You Don't Agree To The Terms Contained In
                            This Agreement, Please Exit the Web Site
                            Immediately.
                        </h5>
                        <br/>
                        <div className="form-group m-form__group i-agree-form">
                            <label className="m-checkbox  m-checkbox--focus mb-0 text-black-50 font-weight-normal">
                                <input type="checkbox" id="i_agree" className="mr-2 i-agree-text"
                                    name="i_agree"
                                    defaultChecked={this.state.i_agree}
                                    onChange={this.handleChange} />
                                I Agree
                                <span></span>
                                { (this.state.displayError) && <div className="text-danger">This field is required.</div>}
                            </label>
                        </div>
                        <div className="m-login__form-action form-group m-form__group">
                            <button id="m_login_signin_submit"
                                    className="btn-primary btn btn-focus m-btn m-btn--pill m-btn--custom m-login__btn m-login__btn--primary m-0 text-uppercase shadow-none font-weight-bold py-2">
                                Continue
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
            </>
        )
    }
}

export default (Privacy);
